import PageMessage from './PageMessage';

export default PageMessage;
